import type { ReactNode } from 'react';
import { Maximize2 } from 'lucide-react';

import { getLocale } from '../../../i18n';
import { count } from '../../../chrome/measure/format';
import { Absent } from '../../../chrome/measure';
import { IconHint } from '../../../chrome/hint';
import { RankRow } from '../../../chrome/chart';
import { tilesUrlOf } from '../../../lib/config';
import { Badge } from '../../../ui/badge';
import { territoryPath } from '../territory/paths';
import { TerritoryMap } from '../territory/TerritoryMap';
import { fractionsOf } from './figures';
import { NoReading } from './MetricsGrid';
import { ov } from './messages';
import { OverviewCard } from './OverviewCard';
import type { Overview } from '../api/schemas';

function counted(value: number | null): ReactNode {
  return value === null ? <Absent reason="not_measured" /> : count(value, getLocale());
}

export function TerritoryCard(props: {
  campaignId: string;
  territory: Overview['territory'];
}): ReactNode {
  const territory = props.territory ?? [];
  const shares = fractionsOf(territory.map((row) => row.value));

  return (
    <OverviewCard
      title={ov('territory.title')}
      aside={
        <div className="flex items-center gap-2">
          <Badge variant="outline">{ov('territory.scope')}</Badge>
          <IconHint label={ov('territory.open')}>
            <a
              href={territoryPath(props.campaignId)}
              className="text-muted-foreground hover:text-foreground"
            >
              <Maximize2 aria-hidden className="size-4" />
            </a>
          </IconHint>
        </div>
      }
    >
      <TerritoryMap tilesUrl={tilesUrlOf()} compact />
      {territory.length === 0 ? (
        <NoReading />
      ) : (
        territory.map((row, index) => (
          <RankRow
            key={row.locality_id}
            label={row.name}
            value={counted(row.value)}
            share={shares[index]}
            tone="positive"
          />
        ))
      )}
    </OverviewCard>
  );
}
